export const UrlSegmentDelimiter = '/';
export const SkipErrorInterceptor = 'skipErrorInterceptor';

// Admin layout
export const AdminLayoutWrapperCSSClass = 'wrapper';

// CSS dialog
export const TabStripDialogContentCSSSelector = '.k-dialog-wrapper .k-tabstrip .k-tabstrip-content';
